export const createEmptyInputState = () => ({
    text: '',
    voice: { status: 'idle' },
    attachments: [],
    useBigModel: false,
});
export const MAX_ATTACHMENTS = 10;
export const ALLOWED_ATTACHMENT_TYPES = {
    image: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'],
    pdf: ['application/pdf'],
    xlsx: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
    ],
};
export const getAttachmentType = (mimeType) => {
    if (mimeType.startsWith('image/')) {
        return 'image';
    }
    if (ALLOWED_ATTACHMENT_TYPES.pdf.includes(mimeType)) {
        return 'pdf';
    }
    if (ALLOWED_ATTACHMENT_TYPES.xlsx.includes(mimeType)) {
        return 'xlsx';
    }
    return null;
};
export const getAttachmentUrl = (guid) => `https://storage.trionline.com.au/get-v3/${guid}`;
//# sourceMappingURL=types.js.map